import { apiClient } from '../../../../../../../../api';
import { ValidateAndUploadView } from '../../../../../../../../components/validate-upload-view/ValidateAndUploadView';
import { MentionsSchedulesPreview } from './MentionsSchedulesPreview';
import { Station } from '@app/core/types/stations';

export function MentionsSchedulesCsvUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadView
      allowedExtensions={['.csv']}
      validateFn={(file: File) =>
        apiClient.audit.pntSchedulesCsvValidate({
          stationId: station.id,
          file,
        })
      }
      importFn={(file: File) =>
        apiClient.audit.pntSchedulesCsvImport({
          stationId: station.id,
          file,
        })
      }
      renderPreview={(data) => <MentionsSchedulesPreview data={data} />}
    />
  );
}
